<template>
    <span class="precio-syb" v-if="displayNumber">{{miles(displayNumber)}}</span>
    <span v-else>-</span>
</template>
<script>

    import constantes from "../constantes";

    export default {
        name: "numero-animado",
        props:{'number':{default:0}},
        data: ()=>({
            displayNumber:0,
            interval:false
        }),
        ready:function(){
            this.displayNumber = this.number;
        },
        watch:{
            number: function(){
                clearInterval(this.interval);
                if(this.number === this.displayNumber){
                    return;
                }
                this.interval = window.setInterval(function(){
                    if(this.displayNumber !== this.number){
                        let change = (this.number - this.displayNumber) / 10;
                        this.displayNumber = this.displayNumber + change;
                    }
                }.bind(this), 10.1);
            }
        },
        methods:{
            miles:(numero)=>constantes.funciones.puntoMilesDecimal(numero)
        },
        created() {
            this.displayNumber = this.number;
        }
    }
</script>

<style scoped>

</style>
